__turbopack_context__.v({
  "root": "KI5skW_root",
});
